import type { CheckoutTracker } from '@gig/checkout-shared-tracker';
import type { IOrderInfo } from '../types/order.js';
import { buildFrontCashierOrderContext, createFrontTracker } from './index.js';

/**
 *
 * 创建收银台壳层使用的 tracker。
 *
 * 该函数只负责 front 自己的 redirect 会话初始化，
 * 不承担任何支付核心事件上报逻辑。
 *
 * @returns 收银台壳层使用的 tracker 实例
 */
export function createFrontCashierTracker(): CheckoutTracker {
  return createFrontTracker();
}

/**
 *
 * 在收银台壳层拿到 `dispatch-order` 成功结果后同步订单上下文。
 *
 * front 只需要把订单基础字段补齐给 tracker，随后通过 `exportBridgeContext()`
 * 把同一条 session 透传给 `checkout-web` 即可。
 *
 * @param tracker 当前收银台壳层持有的 tracker
 * @param orderInfo `dispatch-order` 事件返回的订单信息
 */
export function syncFrontCashierOrder(tracker: CheckoutTracker, orderInfo: IOrderInfo): void {
  tracker.updateOrderContext(buildFrontCashierOrderContext(orderInfo));
}
